<template>
  <div
    class="flex flex-wrap col-12 items-center h4n border-top border-bottom py2 px3"
  >
    <span class="flex h5 mb1"> Détails: </span>
    <ul class="col-12 mb3">
      <li
        v-for="(detail, index) in details"
        :key="`${detail.categoryLabel || detail.price_category}-${index}`"
        class="col-12"
      >
        <div class="flex flex-wrap col-12 md-col-9 lg-col-9 items-center">
          <div class="flex col-12">
            <span class="flex col-12 lg-col-8 bold h6">{{ detail.categoryLabel || detail.price_category }} (x{{
              detail.quantity
            }})</span>
            <div v-if="!detail.gymlibCode" class="flex flex-wrap col-12 lg-col-4 justify-end">
              <div
                v-if="
                  parseFloat(detail.price / 100) < computeOriginalPrice(detail)
                "
                class="flex justify-end col-12 crossed"
              >
                {{ computeOriginalPrice(detail).toFixed(2) }} €
              </div>
              <div
                v-if="priceWithDecimals(detail.price) > 0"
                class="flex flex-wrap justify-end col-12 right"
              >
                <div class="flex justify-end">
                  {{ priceWithDecimals(detail.price / 100) }} €
                </div>
                <div
                  v-if="commonAttributes.recurring"
                  class="flex ml1 h6 justify-end"
                >
                  / mois
                </div>
              </div>
              <div v-else class="flex col-12 right justify-end">Offert</div>
            </div>
          </div>
          <div v-if="detail.gymlibCode" class="flex col-12 h6">Code EGYM Wellpass: {{ detail.gymlibCode }}</div>
          <div v-if="!detail.gymlibCode" class="flex col-12 h6">
            {{
              priceWithDecimals(detail.price / 100 / (detail.quantity || 1))
            }}
            €
          </div>
        </div>
      </li>
    </ul>
    <span v-if="computedOptions.length" class="flex h5 mb1"> Options: </span>
    <ul v-if="computedOptions.length" class="col-12">
      <li
        v-for="(option, i) in computedOptions"
        :key="`${option.name}-${i}`"
        class="col-12"
      >
        <div class="flex flex-wrap col-12 md-col-9 lg-col-9 items-center">
          <div class="flex col-12">
            <span class="flex col-12 lg-col-8 bold h6">{{ option.name }} (x{{ option.quantity }})</span>
            <div class="flex flex-wrap col-12 lg-col-4 justify-end">
              <div
                v-if="
                  parseFloat(option.price / 100) < computeOriginalPrice(option)
                "
                class="flex justify-end col-12 crossed"
              >
                {{ computeOriginalPrice(option).toFixed(2) }} €
              </div>
              <div
                v-if="priceWithDecimals(option.price) > 0"
                class="flex flex-wrap justify-end col-12 right"
              >
                <div class="flex justify-end">
                  {{ priceWithDecimals(option.price / 100) }} €
                </div>
                <div
                  v-if="commonAttributes.recurring && !option.registrationFees"
                  class="flex ml1 h6 justify-end"
                >
                  / mois
                </div>
              </div>
              <div v-else class="flex col-12 right justify-end">Offert</div>
            </div>
          </div>

          <div class="flex col-12 h6">
            {{
              priceWithDecimals(option.price / 100 / (option.quantity || 1))
            }}
            €
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { priceWithDecimals } from '@/utils/labels';

export default {
  props: {
    details: Array,
    commonAttributes: Object
  },
  computed: {
    tariffs () {
      return this.$store.state.cartItem.tariffs;
    },
    computedOptions () {
      const options = [];

      this.details.forEach(detail => {
        if (detail.options) {
          detail.options.forEach(option => {
            options.push({ ...option, quantity: option.quantity || 1 });
          });
        }
      });

      return options;
    }
  },
  methods: {
    priceWithDecimals,
    computeOriginalPrice (detail) {
      let price = null;
      const originalTariff = this.tariffs.find(
        t => t.tariffCategoryCode === detail.tariffCategoryCode
      );
      if (detail.hasOwnProperty('options')) {
        price = originalTariff.price * detail.quantity;
      } else {
        const originalOption = originalTariff.options.find(
          o => o.price.tariffCode === detail.tariffCode
        );
        const detail_aux = this.details.find(
          d => d.tariffCategoryCode === detail.tariffCategoryCode
        );
        const option = detail_aux.options.find(
          o => o.tariffCode === detail.tariffCode
        );
        const quantity = option.quantity || 1;
        price = originalOption.price * quantity;
      }
      return parseFloat(parseInt(price) / 100);
    }
  }
};
</script>
